import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import VrunFormLangSelect from './VrunFormLangSelect.vue'

registerVueComponentAndAngularBindings('vrun_form:lang_select:component', 'vrunFormLangSelect', VrunFormLangSelect)